var map = {
	"./1-15A.png": 10429,
	"./1-15B.png": 69190,
	"./1-15C.png": 8207,
	"./1-15D.png": 65360,
	"./1-15E.png": 62265,
	"./16-30A.png": 57126,
	"./16-30B.png": 98365,
	"./16-30C.png": 77236,
	"./16-30D.png": 23147,
	"./16-30E.png": 2018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42163;